import React from "react"
import Image from "../components/image"

export default function MegaQuote({ img, alt, quote, name, jobTitle }) {
  return (
    <section className="mega-quote">
      <div className="mega-quote__content">
        <div className="mega-quote__content__quote">{quote}</div>
        <div className="mega-quote__content__attribution">
          <div className="mega-quote__content__name">{name}</div>
          <div className="mega-quote__content__job-title">{jobTitle}</div>
        </div>
      </div>
      <Image
        path={img}
        alt={alt}
        className="mega-quote__image"
        imgStyle={{ objectPosition: "left center" }}
      />
    </section>
  )
}
